import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const UserIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-user${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M5.33337 4.66667C5.33337 5.37391 5.61433 6.05219 6.11442 6.55229C6.61452 7.05238 7.2928 7.33333 8.00004 7.33333C8.70728 7.33333 9.38556 7.05238 9.88566 6.55229C10.3858 6.05219 10.6667 5.37391 10.6667 4.66667C10.6667 3.95942 10.3858 3.28115 9.88566 2.78105C9.38556 2.28095 8.70728 2 8.00004 2C7.2928 2 6.61452 2.28095 6.11442 2.78105C5.61433 3.28115 5.33337 3.95942 5.33337 4.66667Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 14V12.6667C4 11.9594 4.28095 11.2811 4.78105 10.781C5.28115 10.281 5.95942 10 6.66667 10H9.33333C10.0406 10 10.7189 10.281 11.219 10.781C11.719 11.2811 12 11.9594 12 12.6667V14"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default UserIcon;
